import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _DigitalLendingFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.1016 3.30054C22.7584 3.30054 24.1016 4.64368 24.1016 6.30054V9.30054H20.8516C20.4373 9.30054 20.1016 9.63632 20.1016 10.0505C20.1016 10.4648 20.4373 10.8005 20.8516 10.8005H24.1016V18.3005C24.1016 19.9574 22.7584 21.3005 21.1016 21.3005H3.10156C1.44471 21.3005 0.101562 19.9574 0.101562 18.3005V10.8005H3.35156C3.76578 10.8005 4.10156 10.4648 4.10156 10.0505C4.10156 9.63632 3.76578 9.30054 3.35156 9.30054H0.101562V6.30054C0.101562 4.64368 1.44471 3.30054 3.10156 3.30054H10.0488V6.36499C9.50669 6.37636 8.96727 6.56159 8.52344 6.92358L8.33398 7.09546C7.35784 8.07174 7.35784 9.65434 8.33398 10.6306L10.7715 13.0681L10.9619 13.241C11.4178 13.6121 11.9758 13.7976 12.5303 13.7996C12.5325 13.7996 12.5348 13.7996 12.5371 13.7996C12.5394 13.7996 12.5417 13.8005 12.5439 13.8005L12.543 13.7996C13.1945 13.801 13.8365 13.548 14.3164 13.0681L16.7227 10.6619L16.8945 10.4724C17.642 9.55591 17.6421 8.23262 16.8945 7.31616L16.7227 7.12671L16.5332 6.95483C16.1006 6.60198 15.5771 6.41791 15.0488 6.39819V3.30054H21.1016ZM3.10156 16.5505C2.68735 16.5505 2.35156 16.8863 2.35156 17.3005C2.35156 17.7148 2.68735 18.0505 3.10156 18.0505H7.10156C7.51578 18.0505 7.85156 17.7148 7.85156 17.3005C7.85156 16.8863 7.51578 16.5505 7.10156 16.5505H3.10156Z"
        fill={iconColor}
      />
      <Path
        d="M15.79 8.34351L15.8408 8.42944C15.8256 8.4004 15.8083 8.37125 15.79 8.34351L15.7305 8.26343C15.7517 8.28946 15.7718 8.31596 15.79 8.34351Z"
        fill={iconColor}
      />
      <Path
        d="M9.2666 8.31323L9.21582 8.39819C9.23119 8.36891 9.24812 8.34119 9.2666 8.31323L9.32617 8.23218C9.30477 8.25841 9.28494 8.28545 9.2666 8.31323Z"
        fill={iconColor}
      />
      <Path
        d="M14.4053 8.05933C14.3498 8.09596 14.2969 8.13839 14.248 8.18726C14.2726 8.16274 14.2979 8.13935 14.3242 8.11792L14.4053 8.05933Z"
        fill={iconColor}
      />
      <Path
        d="M15.5859 8.11792L15.6621 8.18726C15.6377 8.16285 15.6121 8.13928 15.5859 8.11792L15.5049 8.05933C15.5325 8.07755 15.5598 8.09667 15.5859 8.11792Z"
        fill={iconColor}
      />
      <Path
        d="M9.4707 8.08765L9.39453 8.15601C9.41905 8.13149 9.44439 8.10908 9.4707 8.08765L9.55176 8.02808C9.52397 8.04641 9.49694 8.06625 9.4707 8.08765Z"
        fill={iconColor}
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5488 2.00049C13.1011 2.00049 13.5488 2.4482 13.5488 3.00049V8.88632L14.248 8.18726C14.6386 7.79673 15.2716 7.79673 15.6621 8.18726C16.0526 8.57778 16.0527 9.21087 15.6622 9.60139L13.2559 12.0076C13.0628 12.2008 12.8039 12.3025 12.5411 12.3005C12.2845 12.3011 12.0277 12.2034 11.832 12.0076L9.39446 9.57014C9.00393 9.17962 9.00401 8.54653 9.39453 8.15601C9.78506 7.76548 10.4181 7.76541 10.8087 8.15593L11.5488 8.89609V3.00049C11.5488 2.4482 11.9965 2.00049 12.5488 2.00049Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const DigitalLendingFilledIcon = assignWithoutSideEffects(_DigitalLendingFilledIcon, {
  componentId: 'DigitalLendingFilledIcon',
});

export default DigitalLendingFilledIcon;
